import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { ShowForRolesDirective } from '@directives/show-for-roles.directive';
import { UploadComponent } from './upload/upload.component';

@Component({
  selector: 'app-constancia-situacion-fiscal',
  imports: [CommonModule, BackboneComponent, BreadcrumbComponent, TagModule, TabViewModule, ShowForRolesDirective, UploadComponent],
  templateUrl: './constancia-situacion-fiscal.component.html',
  styleUrl: './constancia-situacion-fiscal.component.scss',
})
export class ConstanciaSituacionFiscalPage {}
